<template>
  <v-dialog
    v-model="dialog"
    width="800"
    >
    <v-card
      class="py-3"
      v-if="contact"
      >
      <v-card-title>
        Editar cliente
        <v-spacer></v-spacer>
        <v-btn
          @click="$refs.deleting.dialog = true"
          icon>
          <v-icon color="error darken-1">mdi-delete</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col
            cols="12"
            class="text-body pb-0">
            Nombre
          </v-col>
          <v-col
            cols="12"
            class="text-subtitle-1 py-0 black--text">
            <v-text-field
              class="pt-0"
              hide-details="auto"
              v-model="contact.profile.name">
            </v-text-field>
          </v-col>

          <v-col
            cols="12"
            class="text-body pb-0">
            {{ $t('contact.show.fields.address') }}
          </v-col>
          <v-col
            cols="12"
            class="text-subtitle-1 py-0 black--text">
            <v-text-field
              class="pt-0"
              hide-details="auto"
              v-model="contact.profile.address">
            </v-text-field>
          </v-col>

          <v-col
            cols="12"
            class="text-body pb-0">
            {{ $t('contact.show.fields.email') }}
          </v-col>
          <v-col
            cols="12"
            class="text-subtitle-1 py-0 black--text">
            <v-text-field
              class="pt-0"
              hide-details="auto"
              v-model="contact.profile.email">
            </v-text-field>
          </v-col>

          <v-col
            cols="12"
            class="text-body pb-0">
            {{ $t('contact.show.fields.phone') }}
          </v-col>
          <v-col
            cols="12"
            class="text-subtitle-1 py-0 black--text">
            <v-text-field
              class="pt-0"
              hide-details="auto"
              v-model="contact.profile.phone">
            </v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions
        class="px-6 py-3 justify-end">
        <v-btn
          @click.stop="dialog = false"
          text>
          {{ $t('action.cancel') }}
        </v-btn>

        <v-btn
          @click.stop="edit"
          color="primary">
          {{ $t('action.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <Modal
      v-if="contact"
      ref="deleting">
      <v-card>
        <v-card-title>
          {{ $t('contact.show.delete_modal.title') }}
        </v-card-title>
        <v-card-text>
          {{ $t('contact.show.delete_modal.confirm_message', { name: contact.profile.name }) }}
        </v-card-text>
        <v-card-actions
          class="px-6 py-3 justify-end">
          <v-spacer></v-spacer>
          <v-btn
            text
            @click.stop="$refs.deleting.dialog = false">
            {{ $t('action.cancel') }}
          </v-btn>
          <v-btn
            color="primary"
            @click.stop="deleteContact">
            {{ $t('action.confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </Modal>
  </v-dialog>
</template>

<script>
import { Contact } from '@/graphql/queries/directory'
import { EditContact, DeleteContact } from '@/graphql/mutations/directory'
import Modal from '@/components/modals/NoActivator'

export default {
  data () {
    return {
      contact: null,
      dialog: false
    }
  },

  props: {
    contact_id: {
      required: true,
    },
  },

  components: {
    Modal
  },

  watch: {
    contact_id: {
      handler() {
        this.fetchContact()
      }
    }
  },

  created () {
    this.fetchContact()
  },

  methods: {
    show () {
      this.$refs.modal.dialog = true
    },

    fetchContact (policy = 'no-cache') {
      this.$apollo.query({
        query: Contact,
        variables: {
          contactId: this.contact_id
        },
        fetchPolicy: policy
      }).then(res => {
        this.contact = res.data.contact
      })
    },

    edit () {
      this.$apollo.mutate({
        mutation: EditContact,
        variables: {
          input: {
            userId: this.contact.id,
            contactAttributes: {
              name: this.contact.profile.name,
              address: this.contact.profile.address,
              email: this.contact.profile.email,
              phone: this.contact.profile.phone,
              dni: this.contact.profile.dni
            }
          }
        }
      }).then( res => {
        this.dialog = false
        this.$emit('reload')
      })
    },

    deleteContact () {
      this.$apollo.mutate({
        mutation: DeleteContact,
        variables: {
          input: {
            userId: this.contact.id
          }
        }
      }).then( res => {
        if (res.data.deleteContact.success) {
          this.dialog = false
          this.$emit('reload')
        }
      })
    }
  }
}
</script>
